// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__2Ekni","title":"ClientInsurance_title__1dXoc","itemText":"ClientInsurance_itemText__2-2mC"};